import * as React from "react";
import styled from "../../../styled";
import { shadeAlternate } from "../../../styled/helpers";
const Wrapper = styled("div") ``;
const ItemComponent = styled("div") `

  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 12px 15px;
  border: 1px solid ${({ theme }) => theme.box.border};
  color: ${({ theme }) => theme.box.text};
  transition: 0.23s all;
  font-weight: 500;
  font-size: ${({ theme }) => theme.font.size}px;
  
  > .check-circle {
    transition: 0.23s all;
    border: 2px solid ${({ theme }) => shadeAlternate(0.1, theme.box.border)};
    border-radius: 50%;
    width: 12px;
    height: 12px;
    &:after {
      content: " ";
    }
  }
  > .content {
    margin-left: 15px;
    flex-grow: 1;
  }
  
  &:hover, &.active {
    transform: scale(1.015);
    border: 1px solid ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
    > .check-circle {
      border: 1px solid ${({ theme }) => theme.colors.primary};
      background: ${({ theme }) => theme.colors.primary};
      width: 14px;
      height: 14px;
    }
  }
  
  &:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  
`;
export const Item = (props) => (React.createElement(ItemComponent, { className: props.active ? "active" : "", onClick: props.onClick },
    React.createElement("div", { className: "check-circle" }),
    React.createElement("div", { className: "content" }, props.children)));
export class ListSelect extends React.Component {
    render() {
        const { items, selected, onChange } = this.props;
        return (React.createElement(Wrapper, null, items.map((item, i) => (React.createElement(Item, { key: i, active: selected === item.value, onClick: () => onChange(item.value), children: item.render() })))));
    }
}
//# sourceMappingURL=index.js.map